// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"oF-z","smallCardRow":"pF-z","largeCardRow":"qF-z","productSearchRow":"rF-z","curatedRow":"sF-z"};